//封装axios请求
//1.导入axios
import ax from "axios";
import commonParam from "../param/commonParam";
import router from "../router/index";
import { getToken } from "./tokenUtil";
import { clearData, setData } from "@/store/storeUtil";
import { MessageBox, Message } from "element-ui";

const instance = ax.create({
  baseURL: commonParam.serverUrl
})

// 请求拦截器(给后台发送的请求)
instance.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  let url = config.url;
  // get参数编码
  if (config.method === "get" && config.params) {
    url += "?";
    let keys = Object.keys(config.params);
    for (let key of keys) {
      url += `${key}=${encodeURIComponent(config.params[key])}&`;
    }
    url = url.substring(0, url.length - 1);
    config.params = {};
  }
  config.url = url;
  return config;
})

// 响应拦截器（后台返回来的参数）
instance.interceptors.response.use(
  response => {
    const respData = response.data;
    if (respData.message && (respData.message.indexOf("Headers中没有token信息") >= 0 || respData.message.indexOf("未登录或Token已过期") >= 0)) {
      Message.warning({ message: '登录信息已失效，请重新登录！' });
      setData("toLogin", true);
      clearData();
      location.href = "/";
      // router.replace({
      //   path: '/login',
      //   name: 'Login',
      // });
      // MessageBox.confirm("账号未登录或登录已过期，请重新登录！", "提示", {
      //   showClose: false,
      //   closeOnClickModal: false,
      //   closeOnPressEscape: false,
      //   showCancelButton: false,
      //   type: "warning"
      // }).then(() => {
      //   setData("toLogin", true);
      //   clearData();
      //   router.replace("/login");
      // }).catch(() => { });
    }
    return respData
  }, error => {
    if (error.response.data.message.indexOf("Headers中没有token信息") >= 0) {
      Message.warning({ message: '登录信息已失效，请重新登录！' });
      setData("toLogin", true);
      clearData();
      location.href = "/";
      // router.replace({
      //   path: '/login',
      //   name: 'Login',
      // });
      // MessageBox.confirm("账号未登录或登录已过期，请重新登录！", "提示", {
      //   showClose: false,
      //   closeOnClickModal: false,
      //   closeOnPressEscape: false,
      //   showCancelButton: false,
      //   type: "warning"
      // }).then(() => {
      //   setData("toLogin", true);
      //   clearData();
      //   router.replace("/login");
      // }).catch(() => { });
    } else {
      setData("toLogin", false);
      Message.warning({
        message: error.response.data.message, showClose: true
      });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
    return Promise.reject(error); //接口500抛出异常（不走页面逻辑）
  }
)

export default instance;
